// 封装所有的请求
import http from './index';
import { BDRequest } from '../http';

const OAUTH_CLIENT_ID = process.env.VUE_APP_CLIENT_ID;
const OAUTH_CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET;
const OAUTH_BASIC_AUTH = `Basic ${window.btoa(`${OAUTH_CLIENT_ID}:${OAUTH_CLIENT_SECRET}`)}`;

// 在index 文件下已将axios变为http
export default {
  // get参数不用{}包裹
  // 首页数据
  index() {
    return http.get('/recommend');
  },

  // 主题 / 活动 / D区 / Banner
  getQueryRotation(data) {
    return http({
      url: `/product/order/queryRotation`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 主题 活动 banner点击查询分类信息
  queryTopicBooleanAndCategory(data) {
    return http({
      url: `/product/info/queryTopicBooleanAndCategory`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 搜索
  search({ value }) {
    return http.post('/search', {
      value,
    });
  },

  // 查询一二级分类（一次返回，包含children）
  selectCategoryWithChildren(bathId, upgradeFlag, cityCode, navScope) {
    const cardId = localStorage.getItem('cardId') || '';
    let url = `/product/category/selectCategoryWithChildren?bathId=${bathId}&upgradeFlag=${upgradeFlag}&cityCode=${cityCode}&cardId=${cardId}`;
    if (navScope) {
      url += `&navScope=${navScope}`;
    }
    return http({
      url,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 分类二级目录查询
  queryLabel(data) {
    return http({
      url: `/hostShow/queryLabel`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  sendSms(mobile) {
    return http({
      url: `/user/sendSms?mobile=${mobile}`,
      method: 'get',
    });
  },
  //登录手机号是否绑定微信
  confirmWxByMobile(mobile) {
    return http({
      url: `/wechat/confirmWxByMobile?mobile=${mobile}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //查询未支付订单
  queryUnpaidOrderInfo(userId) {
    return http({
      url: `/order/movie/queryUnpaidOrderInfo?userId=${userId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  sendPaySms(mobile) {
    return http({
      url: `/user/sendPaySms?mobile=${mobile}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //上传code
  codeCallback(code) {
    return http({
      url: `/wechat/callback?code=${code}`,
      method: 'get',
    });
  },
  // 绑定手机号
  bindUserByOpenId(data) {
    return http({
      url: `/wechat/bindUserByOpenId`,
      method: 'post',
      data: data,
    });
  },
  // 微信绑定手机号列表
  queryUserMobiles(openId) {
    return http({
      url: `/wechat/queryUserMobiles?openId=${openId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  loginSms(username, smsCode) {
    return http({
      url: `/oauth/token?grant_type=sms_code&platform=H5&scope=server&username=${username}&smsCode=${smsCode}`,
      method: 'post',
      headers: {
        Authorization: OAUTH_BASIC_AUTH,
      },
    });
  },
  loginWechat(username, mobile) {
    return http({
      url: `/oauth/token?grant_type=wechat_code&platform=H5&scope=server&username=${username}&mobile=${mobile}`,
      method: 'post',
      headers: {
        Authorization: OAUTH_BASIC_AUTH,
      },
    });
  },
  // 查询收货地址
  getAddress(userId) {
    return http({
      url: `/address/queryAddress?userId=${userId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 添加收货地址
  addAddress(data) {
    return http({
      url: `/address/addAddress`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 修改收货地址
  updateAddress(data) {
    return http({
      url: `/address/updateAddress`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //查询城市热映影片
  queryHotMoviesByCity(cardId, cityId, filmName) {
    return http({
      url: `/movieMall/queryHotMoviesByCity?cardId=${cardId}&cityId=${cityId}&filmName=${filmName}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  
  //待放映影片
  queryWaitShowMovie(data) {
    return http({
      url: `/movieMall/queryWaitShowMovie`,
      method: 'get',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //查询城市影院列表
  queryCinemas(data) {
    return http({
      url: `/movieMall/queryCinemas`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //根据影片查影院和场次
  queryFutureFilmsByFilmId(data) {
    return http({
      url: `/movieMall/queryFutureFilmsByFilmId`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //根据影片查影院和场次
  queryShowsByMovieAndFilm(data) {
    return http({
      url: `/movieMall/queryShowsByMovieAndFilm`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //根据影院查影片
  queryAllFilms(data) {
    return http({
      url: `/movieMall/queryAllFilms`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //查询座位
  queryShowSeats(data) {
    return http({
      url: `/movieMall/queryShowSeats`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //锁座
  lockOrder(data) {
    return http({
      url: `/movieMall/lockOrder`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //电影订单
  queryMovieOrderInfo(data) {
    return http({
      url: `order/movie/queryMovieOrderInfo`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //全部订单
  queryOrderInfo(data) {
    return http({
      url: `/product/order/queryOrderInfo`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //取消订单
  cancelPayment(tripartiteOrderId) {
    return http({
      url: `/order/movie/cancelPayment?tripartiteOrderId=${tripartiteOrderId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //自营取消订单
  productcancelPayment(tripartiteOrderId) {
    return http({
      url: `/product/order/cancelPayment?tripartiteOrderId=${tripartiteOrderId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 加入购物车
  addShop(data) {
    return http({
      url: `/shoppingCart/add`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  prePurchase(data) {
    return http({
      url: `/product/order/prePurchase`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 统一提交订单接口
  productOrderInfo(data) {
    return http({
      url: `/product/order/submitOrderInfo`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 查询出票详情（按订单号）
  queryMovieTicketDetail(orderNo) {
    return http({
      url: `/movieTicketDetail/queryMovieTicketDetail?orderNo=${encodeURIComponent(orderNo)}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 购物车数据
  queryShoppingCart(data) {
    return http({
      url: `/shoppingCart/queryShoppingCart`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 删除购物车数据
  deleteShop(data) {
    return http({
      url: `/shoppingCart/deleteShoppingCart`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 修改购物车单个商品数量
  updateNum(data) {
    return http({
      url: `/shoppingCart/updateNum`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 扫一扫获取微信相关参数
  wxUrlSign(str) {
    return http({
      url: `/wechat/wxUrlSign?url=${encodeURIComponent(str)}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 上传扫一扫结果
  boundBenefitCardByQR(str, ticketType) {
    return http({
      url: `/benefitCardInfo/boundBenefitCardByQR?qrCodeContent=${str}&ticketType=${ticketType}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 获取卡号信息
  checkBenefitCard(data) {
    return http({
      url: `/cardPwd/checkBenefitCard`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 绑卡
  bindCard(data) {
    return http({
      url: `/cardPwd/bindBenefitCard`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 福利卡列表
  cardList(data) {
    return http({
      url: `/cardPwd/queryBindBenefitCard`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 判断是否有首页标识
  isHomeShow(data) {
    const cardId = data.cardId || localStorage.getItem('cardId') || '';
    return http({
      url: `/product/category/ifShowHomePage?bathId=${data.bathId}&upgradeFlag=${data.upgradeFlag}&cardId=${cardId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 福利卡个数
  cardAvaAndUnAvaNum(data) {
    return http({
      url: `/cardPwd/cardAvaAndUnAvaNum`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 保存贺卡签收记录
  saveGreetingCardSignature(data) {
    // 如果是FormData，不设置Content-Type，让浏览器自动设置
    const headers = { Authorization: 'Bearer ' + this.getToken() };
    if (!(data instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }
    return http({
      url: `/greetingCard/saveGreetingCardSignature`,
      method: 'post',
      data: data,
      headers: headers,
    });
  },
  //福利卡升级
  cardUpgrade(cardId) {
    return http({
      url: `/cardPwd/cardUpgrade?cardId=${cardId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 商家地址列表
  getShopList(addressId, brandId) {
    return http({
      url: `/order/cake/getShopList?addressId=${addressId}&brandId=${brandId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  /**
   * 电商获取当前商品配送规则及是否合规
   * @param {*} data {
   *    cityCode: "", 城市code
   *    specId: "", 规格标识
   *    addrId: "", 平台收货地址主键 t_address.id
   *    quantitys: "" 购买数量
   *    distributionRuleId: "" 配送规则id
   * }
   * @returns
   */
  queryDistributionRules(data) {
    return http({
      url: `/cakeMall/queryAllDistributionRules`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  /**
   * 电商获取详情请求接口
   * @param {*} data {
   *    cardId: "",
   *    cityCode: "",
   *    brandId: "",
   *    productId: ""}
   * @returns
   */
  queryAllGoodsDetail(data) {
    return http({
      url: `/cakeMall/queryAllProductDetail`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //查看首页商品信息
  queryProductInfoHomeNew(data) {
    return http({
      url: `/product/info/queryProductInfoHomeNew`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 结算预处理（生成结算快照）
  prepareCheckoutSnapshot(data) {
    return http({
      url: `/product/order/prepareCheckoutSnapshot`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 查询结算快照
  getCheckoutSnapshot(key) {
    return http({
      url: `/product/order/getCheckoutSnapshot`,
      method: 'get',
      params: { key },
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 确认订单切换地址后重算结算快照
  recalculateCheckoutSnapshot(key, addressId) {
    return http({
      url: `/product/order/recalculateCheckoutSnapshot`,
      method: 'get',
      params: { key, addressId },
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //自营订单详情
  queryOrderInfoDetail(orderNo) {
    return http({
      url: `/product/order/queryOrderInfoDetail?orderNo=${orderNo}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //查看物流
  queryEbusiness(data) {
    return http({
      url: `/OrderLogistics/queryLogisticsInfo`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //确认收货
  confirmReceipt(orderNo, sortId) {
    return http({
      url: `/cakeMall/confirmReceipt?orderNo=${orderNo}&sortId=${sortId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  queryHomePageCategory(bathId, upgradeFlag, cityCode) {
    const cardId = localStorage.getItem('cardId') || '';
    return http({
      url: `/product/category/queryHomePageCategory?bathId=${bathId}&upgradeFlag=${upgradeFlag}&cityCode=${cityCode}&cardId=${cardId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //添加支付密码
  pwdAdd(data) {
    return http({
      url: `/tPayPwd/add`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //更新支付密码
  pwdUpdate(data) {
    return http({
      url: `/tPayPwd/update`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //是否设置过支付密码
  pwdCheck() {
    return http({
      url: `tPayPwd/check`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //密码校验
  pwdContrast(data) {
    return http({
      url: `/tPayPwd/contrast`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //密码校验
  queryThirdAddress(cityCode) {
    return http({
      url: `/movieMall/queryThirdAddress?cityCode=${cityCode}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //卡消费记录
  queryCardExpendByCardId(data) {
    return http({
      url: `/cardExpend/queryCardExpendByCardId`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //企业采购
  addCompanyPurchase(data) {
    return http({
      url: `/companyPurchase/addCompanyPurchase`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  // 商城平台公告（按页面）
  listActiveNotices(pageCode) {
    return http({
      url: `/platform/notice/listActive?pageCode=${encodeURIComponent(pageCode || '')}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  //获取地址列表
  queryCityList(cityName) {
    return http({
      url: `/city/queryCityTripartite?type=1&provinceName=${cityName}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //获取跳转三方链接（淘福客等需 cityCode 时从 localStorage 读取，登录接口会暂存供预下单使用）
  getEntrance(type) {
    const cardId = localStorage.getItem("cardId");
    const cityCode = localStorage.getItem("cityCode");
    let url = `/tripartiteProduct/entrance?cardId=${cardId}&type=${type}`;
    if (cityCode) {
      url += `&cityCode=${cityCode}`;
    }
    return http({
      url,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //美团H5订单详情跳转
  goToMtH5OrderDetail(orderNo) {
    return http({
      url: `/tripartiteProduct/goToMtH5OrderDetail?orderNo=${orderNo}&cardId=${localStorage.getItem("cardId")}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //跳转淘福客H5订单详情
  goToTfkH5OrderDetail(orderNo, orderSortId) {
    return http({
      url: `/tripartiteProduct/goToTfkH5OrderDetail?orderNo=${orderNo}&orderSortId=${orderSortId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //跳转蛋叔H5点餐订单详情
  goToDsH5OrderDetail(orderNo) {
    return http({
      url: `/tripartiteProduct/goToDsH5OrderDetail?orderNo=${orderNo}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //蛋叔H5回跳收银台初始化
  dsH5CashierInit(orderCode) {
    return http({
      url: `/dsH5/cashierInit?orderCode=${orderCode}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  
  //获取卡余额接口
  jumpHomePage(cardId) {
    return http({
      url: `/cardPwd/jumpHomePage?cardId=${cardId}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  //根据订单号查询订单
  checkOrderCreationComplete(orderNo) {
    return http({
      url: `/order/info/checkOrderCreationComplete?orderNo=${orderNo}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 统一支付 - 初始化收银台
  initCashier(orderNo) {
    return http({
      url: `/unifiedPayment/initCashier?orderNo=${orderNo}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 统一支付 - 提交支付
  submitUnifiedPay(data) {
    return http({
      url: `/unifiedPayment/submitUnifiedPay`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },
  // 统一支付 - 取消/释放支付会话锁（用户取消微信支付后调用，以便重新发起支付）
  cancelPaySession(orderNo) {
    return http({
      url: `/unifiedPayment/cancelPaySession?orderNo=${orderNo}`,
      method: 'post',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  /**
   * 封装get方法
   * @param url
   * @param data
   * @returns {Promise}
   */
  gets(url, params = {}) {
    return new Promise((resolve, reject) => {
      http.get(url, {
        params: params,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getToken() {
    return localStorage.getItem('access_token');
  },

  /** 退出：DELETE /token/logout，吊销 token 并清理 user_details */
  logout() {
    const token = this.getToken();
    return http({
      url: '/token/logout',
      method: 'delete',
      headers: token ? { Authorization: 'Bearer ' + token } : {},
    });
  },

  // 预览模式免登录认证
  previewAuth(id) {
    return http({
      url: `/previewLink/auth?grant_type=preview_code&platform=H5&scope=server&id=${id}`,
      method: 'get',
      headers: {
        Authorization: OAUTH_BASIC_AUTH,
      },
    });
  },
  
  // ====================================================================
  // 蛋叔渠道 V2 —— C 端 API（仅详情、配送规则、门店）
  // ====================================================================

  /**
   * V2 商品详情
   * @param {string} cityCode 城市编码
   * @param {string} thirdProductId 商品 id（带 DS 前缀）
   * @param {string} cardId 当前用户使用的福利卡 id（用于按 cardPointType 换算 showPrice / 单位）
   */
  dsV2QueryProductDetail(cityCode, thirdProductId, cardId) {
    return http({
      url: `/dsMallV2/queryProductDetail?cityCode=${encodeURIComponent(cityCode)}&thirdProductId=${encodeURIComponent(thirdProductId)}&cardId=${encodeURIComponent(cardId)}`,
      method: 'get',
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  /**
   * V2 配送规则 —— 支持三方多规格一次拆单
   * @param {*} data {
   *   addressId（我方收货地址 id）,
   *   specIds（逗号分隔，无 DS 前缀）, quantitys（逗号分隔）
   * }
   * 返回 data 为 Map<spec_ids_join, DistributionRulesVO>
   */
  dsV2QueryDistributionRules(data) {
    return http({
      url: `/dsMallV2/queryDistributionRulesV2`,
      method: 'post',
      data: data,
      headers: { Authorization: 'Bearer ' + this.getToken() },
    });
  },

  /** V2 门店列表（门店自提场景） */
  dsV2QueryShopList(thirdBrandId, cityId, lng, lat) {
    let url = `/dsMallV2/queryShopList?thirdBrandId=${encodeURIComponent(thirdBrandId)}&cityId=${encodeURIComponent(cityId)}`;
    if (lng != null && lng !== "" && lat != null && lat !== "") {
      url += `&lng=${encodeURIComponent(lng)}&lat=${encodeURIComponent(lat)}`;
    }
    return http({
      url,
      method: "get",
      headers: { Authorization: "Bearer " + this.getToken() },
    });
  },
};
